'use es6';

import { useRef, useEffect, useState } from 'react';

const useFilterUpdate = (globalFilters, updateCallback, runInitially = false) => {
  const filterContainer = useRef(globalFilters);
  const [ranInitial, setRanInitial] = useState(!runInitially);
  useEffect(() => {
    if (!ranInitial && globalFilters.initialized) {
      updateCallback();
      setRanInitial(true);
    }
  }, [ranInitial, updateCallback, globalFilters]);
  useEffect(() => {
    if (filterContainer.current.initialized && globalFilters.initialized && filterContainer.current !== globalFilters) {
      updateCallback();
    }

    filterContainer.current = globalFilters;
  }, [filterContainer, globalFilters, updateCallback]);
};

export default useFilterUpdate;